<template>
    <div class="avaliacao">
        <template v-if="!respondido">
            Essa informação foi útil?

            <rkm-icon
                :class="['avaliacao-icone', {'avaliacao-icone-desabilitado': !!loading}]"
                @click.native="avaliar(true)"
                icon="thumbs-up"
                title="Sim"
            />

            <rkm-icon
                :class="['avaliacao-icone', {'avaliacao-icone-desabilitado': !!loading}]"
                @click.native="avaliar(false)"
                icon="thumbs-down"
                title="Não"
            />
        </template>

        <template v-else>
            Obrigado pela sua resposta.
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({loading: 'getLoading'}),
    },
    created() {
        this.repositories = {
            funcionalidadeAvaliacaoManual: this.getConectaSusRepository('administracao.funcionalidadeAvaliacaoManual'),
        }
    },
    data: () => ({
        respondido: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        avaliar(util) {
            if (this.loading || this.respondido) {
                return
            }

            this.setLoading()

            this.repositories.funcionalidadeAvaliacaoManual
                .store({
                    modulo: this.modulo,
                    funcionalidade: this.funcionalidade,
                    util,
                })
                .then(() => this.respondido = true)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.respondido = false
        },
    },
    mixins: [error, repository],
    props: {
        modulo: { type: String, required: true },
        funcionalidade: { type: String, required: true },
    },
}
</script>

<style scoped>
.avaliacao {
    border-top: 1px solid #dfdfdf;
    color: #495057;
    margin-top: 15px;
    padding-top: 12px;
    text-align: center;
}

.avaliacao-icone {
    color: #007bff;
    cursor: pointer;
    margin-left: 8px;
}

.avaliacao-icone:hover {
    color: #0056b3;
}

.avaliacao-icone-desabilitado {
    cursor: not-allowed;
    opacity: 0.5;
}
</style>
